const getEnv = (state) => state.env;

const EnvSelectors = {
  makeZgEnv: (state) => getEnv(state).zgEnv,
  makeZgApi: (state) => getEnv(state).zgApi,
  makeMetroidAlicornUrl: (state) => getEnv(state).metroidAlicornUrl,
  makeMetroidAlicornHppConfigId: (state) => getEnv(state).metroidAlicornHppConfigId,
  makeZgApiPublic: (state) => getEnv(state).zgApiPublic,
  makeIsProduction: (state) => getEnv(state).isProduction,
  makeGmapsAPIKey: (state) => getEnv(state).gmapsAPIKey,
};

export default EnvSelectors;
